import axios from 'axios'
import { getToken } from '@/utils/auth'

const exportExcel =  function(data, fileName="报表") {
  axios({
      method: data.method,
      url: econfig.BASE_API + data.url,
      params: data.params,
      responseType: 'blob',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
      }
  }).then((res) => {
      const link = document.createElement('a')
      let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
      })
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)

      link.download = fileName + '.xls' //下载的文件名  注意：加.xls是兼容火狐浏览器
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
  }).catch(error => {
      console.log(error)
  })
}


export default exportExcel



// WEBPACK FOOTER //
// ./src/utils/export.js